import {Box, Grid2 as Grid, Stack, Typography, Button} from "@mui/material";
import {STYLE} from "./STYLES";
import {
  BORDER_RADIUS_OUTER,
  BORDER_RADIUS_INNER,
} from "../../config/themes/theme";

export default function EndHeroSection() {
  return (
    <Box
      sx={{
        mx: "auto",
        width: "80%",
        height: "60vh",
        background:
          "linear-gradient(262deg, #F2D3F9 0%, #F1DFF7 23.14%, #F1E6DB 46.76%, #F1ECE5 71.35%, #DCF4EB 100.27%)",
        backgroundImage: "url(/landing/bg-gradient.png)",
        backgroundSize: "cover",
        backgroundPositionX: "center",
        backgroundPositionY: "top",
        backgroundRepeat: "no-repeat",
        borderRadius: BORDER_RADIUS_OUTER,
      }}>
      <Grid container p={{xs: 4, md: 8}} spacing={2} height="100%">
        <Grid size={{xs: 12, md: 6}}>
          <Stack
            direction="column"
            spacing={2}
            height={"100%"}
            justifyContent={"center"}>
            <Typography sx={STYLE.sectionTitle}>
              The future of learning
            </Typography>
            <Typography sx={STYLE.sectionSubtitle}>
              Join students across the country using PrepGenie to prep smarter,
              track progress, and ace every exam.
            </Typography>
            <Box height={8} />
            <Box
              sx={
                {
                  // p: 0.5,
                  // borderRadius: "12px",
                  // border: "1px solid #CFCFCFA0",
                  // width: "fit-content",
                }
              }>
              <Button variant="contained" sx={STYLE.heroButtonPrimary}>
                Start for free
              </Button>
            </Box>
          </Stack>
        </Grid>
        <Grid size={{xs: 12, md: 6}}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              background: "#D9D9D980",
              borderRadius: BORDER_RADIUS_INNER,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
